export default __webpack_public_path__ + "static/media/illustration.3761319e.svg";